module.exports = __webpack_public_path__ + "static/media/light-motion-leo-station-keeping.26b7616.mp4";